<template>
  <div>
    <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
      <b-spinner label="Loading..."></b-spinner>
    </div>
    <div class="panel-tag mt-3" v-if="!isSpinnerShow && totalEntries == 0">
      {{ $t("table.no_records") }}
    </div>
    <div
      v-if="!isSpinnerShow && totalEntries != 0"
      class="dataTables_wrapper dt-bootstrap4"
    >
      <div class="row justify-content-end">
        <div class="col-auto pt-2">
          <span>{{
            $t("table.pagination", {
              startPage: startPage,
              endPage: endPage,
              totalEntries: totalEntries,
            })
          }}</span>
        </div>
        <div class="col-auto">
          <b-pagination
            class="ml-3"
            v-model="currentPage"
            :per-page="perPage"
            :total-rows="totalEntries"
            @input="handlePagination"
            aria-controls="tblProductItems"
          ></b-pagination>
        </div>
      </div>
      <div class="row" data-spy="scroll" data-target="#itemSP" data-offset="0">
        <div class="col-sm-12 overflow-auto">
          <table
            class="
              table table-sm table-hover table-bordered table-striped
              w-100
              dataTable
              dtr-inline
            "
            role="grid"
            id="packageTable"
            style="height: 1px"
          >
            <thead class="thead-themed">
              <tr>
                <th v-for="tblHeader in fields" :style="tblHeader.style" :key="tblHeader.key">
                  {{ tblHeader.label }}
                </th>
              </tr>
            </thead>
            <template v-for="(items, i) in voucherItems">
              <tbody :key="i">
                <tr @click="toggleCollapse(i)" class="dtrg-group dtrg-start">
                  <td
                    colspan="2"
                    class="text-capitalize fw-700 border-top-bottom-2"
                  >
                    <span class="text-secondary mr-2"
                      ><i class="fas fa-user"></i></span
                    >{{ items.items[0].memberDisplayName }} ({{
                      items.items[0].mobile
                    }})
                  </td>
                  <td class="fw-500 border-top-bottom-2">
                    <span class="badge badge-primary">{{ items.total }}</span>
                  </td>
                  <td class="fw-500 border-top-bottom-2">
                    <span class="badge badge-warning">{{
                      formatPrice(items.amount)
                    }}</span>
                  </td>
                </tr>
              </tbody>
              <transition
                @before-enter="onBeforeEnter"
                @enter="onEnter"
                @leave="onLeave"
                :key="items.id"
              >
              <tbody style="max-height:1000px;" class="overflow-y" v-if="collapse[i]">
                <tr
                  v-for="(item, j) in items.items"
                  :key="item.voucherName"
                  :data-index="j"
                  @click="voucherModal(item)"
                >
                  <td>{{ j + 1 }}</td>
                  <td>{{ item.voucherName }}</td>
                  <td>{{ item.total }}</td>
                  <td>{{ formatPrice(item.amount) }}</td>
                </tr>
              </tbody>

              </transition>
            </template>
          </table>
        </div>
      </div>
    </div>
    <b-modal
     @show="initModal"
      id="voucherModal"
      ref="voucherModal"
      size="lg"
      height="600px"
      width="1000px"
      title="Vouchers"
    >
      <template #modal-header="{ close }">
        <div class="d-flex justify-content-between w-100">
          <h4>Vouchers Balance</h4>
          <!-- Emulate built in modal header close button action -->
          <button class="close mr-3" @click="close()">x</button>
        </div>
      </template>
      <div
        v-if="isSpinnerShow2"
        class="d-flex justify-content-center mt-3 mb-3"
      >
        <b-spinner label="Loading..."></b-spinner>
      </div>
      <template v-if="!isSpinnerShow2 && totalVouchers == 0">
        <div class="d-flex justify-content-center">
          <h1>No Balance Available for voucher!</h1>
        </div>
      </template>
      <template v-if="!isSpinnerShow2 && totalVouchers != 0">
        <div class="d-flex justify-content-between mb-2">
          <div class="d-flex w-50">
            <!-- <b-button
              :class="checkBox ? 'btn-info info' : 'btn-sencondary secondary'"
              size="sm"
              class="w-100 mr-2"
              :disabled="!checkBox"
              @click="title = 'Enter New Unit Price',operation='price',editUnitPrice = '', validationFlag = null"
              v-b-modal.voucherEditModal
              >Edit Price</b-button
            >
            <b-button
              :class="checkBox ? 'btn-info info' : 'btn-sencondary secondary'"
              size="sm"
              class="w-100"
              :disabled="!checkBox"
              v-b-modal.voucherEditModal
              @click="title = 'Enter New Expiry Date',operation='expiry',editExpiryDate = '', validationFlag = null"
              >Edit Expiry Date</b-button
            > -->
          </div>
          <div class="d-flex">
            <span
              class="badge badge-primary p-3 mr-2"
              >
              Total: {{totalVouchers}}
              </span>
              <span
              class="badge badge-success p-3 mr-2"
              >
              Valid: {{validLength}}
              </span>
              <span
              class="badge badge-danger p-3"
              >
              Expiry: {{expiredLength}}
              </span>
            
            
          </div>
        </div>
        <b-table
          hover
          bordered
          :fields="voucherFields"
          :items="voucher.vouchers"
          id="voucherTable"
        >
          <template #head(index)>
            <b-form-checkbox
              id="checkAll"
              name="checkAll"
              value="true"
              unchecked-value="false"
              @change="selectAllVoucher"
            >
            </b-form-checkbox>
          </template>
          <template #head(expiryDate)>
            <div class="d-flex">Expiry Date</div>
          </template>
          <template #head(price)>
            <div class="d-flex">Unit | Price</div>
          </template>
          <template #cell(index)="data">
            <input
              type="checkbox"
              :id="'checkVoucher' + data.index"
              v-model="voucherForm[data.index].view"
              @input="
                voucherForm[data.index].view = !voucherForm[data.index].view
              "
            />
          </template>
          <template #cell(detail)>
            {{ voucher.name }}
          </template>
          <template #cell(price)="data">
            <span>{{ parseFloat(data.item.price).toFixed(2) }}</span>
          </template>
          <template #cell(expiryDate)="data">
            <span>{{
              data.item.expiryDate == 0 ? "-" : data.item.expiryDate
            }}</span>
          </template>
          <template #cell(status)="data">
            <!-- <span class="badge badge-secondary fw-400" v-if="item.expiryDate != 0">Expired</span>  -->
            <span
              class="badge badge-danger fw-400"
              v-if="data.item.deleteDate !== 0"
              >Deleted</span
            >
            <span
              class="badge badge-primary fw-400"
              v-else-if="
                data.item.redeemDate != 0 && data.item.redeemDate != undefined
              "
              >Redeemed</span
            >
            <span
              class="badge badge-secondary fw-400"
              v-else-if="expiryCheck(data.item.expiryDate)"
              >Expiry</span
            >
            <span class="badge badge-success fw-400" v-else>Valid</span>
          </template>
          <!-- <template #cell(rollback)="data">
            <b-button
              variant="danger"
              class="w-100"
              v-if="expiryCheck(data.item.expiredDate)"
              @click="voucherEmit(data.item.trxnID, 'unexpire')"
              >Unexpire</b-button
            >
            <b-button
              class="w-100"
              variant="danger"
              v-else-if="data.item.deleteDate == 0"
              @click="voucherEmit(data.item.trxnID, 'delete')"
              >Delete</b-button
            >
          </template> -->
        </b-table>
      </template>
      <template #modal-footer>
        <div class="d-flex justify-content-end w-100">
          <b-button variant="secondary" @click="$bvModal.hide('voucherModal')">Cancel</b-button>
        </div>
      </template>
    </b-modal>
    <b-modal id="voucherEditModal" size="xl" :title="title">
      <div class="d-flex justify-content-center">
        <div class="col-sm-12" v-if="operation == 'price'">
          <input type="text" v-model="editUnitPrice" class="form-control">
          <span class="text-danger mt-1" v-if="!validationFlag && validationFlag != null">Digits only!</span>
        </div>
          <div class="col-sm-12" v-if="operation == 'expiry'">
          <input type="date" v-model="editExpiryDate" :min="disabledDate" class="form-control">
          <span class="text-danger mt-1" v-if="!validationFlag && validationFlag != null">Invalid Date/No past date!</span>
        </div>
      </div>
      <template #modal-footer>
        <div class="d-flex justify-content-end w-100">
          <b-button variant="primary" class="mr-2" :disabled="!validationFlag || validationFlag == null" @click="editVouchers(operation)">Confirm</b-button>
          <b-button variant="secondary" @click="$bvModal.hide('voucherEditModal')">Cancel</b-button>
        </div>
        </template>
    </b-modal>
  </div>
</template>
<script>
import _ from "lodash";
import { vMaska } from "maska";
import moment from "moment";
import Swal from "sweetalert2";
import {
  handleSessionExpired,
  setReturnData,
} from "../../../../assets/js/dashboard/dashboard";
import { formatPrice } from "../../../../assets/js/dashboard/utilities";
import {
  onBeforeEnter,
  onLeave,
  onEnter,
} from "../../../../assets/js/dashboard/animation";
export default {
  name: "voucherSummaryCustomer",
    directives: { maska: vMaska },
  data() {
    return {
      isSpinnerShow: false,
      filterObj: {},
      voucherItems: [],
      voucherClone: {},
      voucherForm: [],
      exportData: [],
      voucher: {},
      limit: 10000,
      voucherSKU: [],
      page: 0,
      totalEntries: 0,
      totalPage: 0,
      startPage: 1,
      endPage: 0,
      perPage: 100,
      currentPage: 1,
      isSpinnerShow2: false,
      collapse: [],
      expiredLength:0,validLength:0,totalVouchers:0,
      title:"",
      editUnitPrice:"",
      operation:"",
      editExpiryDate:"",
      validationFlag:null
    };
  },
  computed: {
    disabledDate(){
      let now = moment().add(1,"day").format("YYYY-MM-DD");
      return now.toString();
    },
    checkBox() {
      let flag = false;
      this.voucherForm.forEach((item) => {
        if (item.view) {
          flag = true;
        }
      });
      return flag;
    },
    fields() {
      return [
        { key: "index", label: "#", style:"width:10%;"},
        { key: "voucher", label: this.$i18n.t("table.header.voucher"), style:"width:50%;" },
        { key: "total", label: this.$i18n.t("label.total"), style:"width:20%;"},
        { key: "amount", label: this.$i18n.t("table.header.amount"), style:"width:20%;"},
      ];
    },
    voucherFields() {
      return [
        { key: "index", label: "ID" },
        { key: "detail", label: "Detail" },
        { key: "expiryDate", label: "Expiry Date" },
        { key: "price", label: "Unit | Price" },
        { key: "status", label: "Status" },
        // { key: "rollback", label: "" },
      ];
    },
    exportFields() {
      var ret = {};
      ret["#"] = "index";
      ret[this.$i18n.t("table.header.name").toUpperCase()] = "name";
      ret[this.$i18n.t("table.header.contact").toUpperCase()] = "mobile";
      ret[this.$i18n.t("table.header.voucher").toUpperCase()] = "voucher";
      ret[this.$i18n.t("label.total").toUpperCase()] = "total";
      ret[this.$i18n.t("table.header.amount").toUpperCase()] = "amount";
      return ret;
    },
  },
  watch: {
    "$i18n.locale"(val) {
      if (this.$parent.tab == "customer") {
        this.setExportData(this.exportData);
      }
    },
    editUnitPrice(val){
      if(isNaN(val) && val!=''){
        this.validationFlag =false;
      }
      else{
        this.validationFlag = true;
      }
    },
    editExpiryDate(val){
      if(val != ''){
        let inputDate = moment(val);
        if(inputDate > moment())
        this.validationFlag = true;
        else
        this.validationFlag = false;
      }
      else{
        this.validationFlag = false;
      }
    }
  },
  methods: {
    initModal(){
      this.validationFlag = false;
      this.editUnitPrice = "";
      this.editExpiryDate = "";
    },
    onBeforeEnter,
    onLeave,
    onEnter,
    toggleCollapse(i) {
      this.collapse.splice(i, 1, !this.collapse[i]);
    },
    async editVouchers(operation) {
      let text = 0;
      let $vm = this;
      let result = [];
      this.title =
        operation == "price" ? "Enter New Unit Price" : "Enter New Expiry Date";
      $vm.isSpinnerShow2 = true;
          $vm.voucherForm.forEach(async (v) => {
            if (v.view) {
              if (operation.includes("price")) {
                result.push(await $vm.voucherEdit(v.id, this.editUnitPrice, "price"));
                v.price = Number(this.editUnitPrice);
              } else if (operation.includes("expiry")) {
                result.push(await $vm.voucherEdit(v.id, this.editExpiryDate, "expiry"));
              }
            }
          });
          this.$bvModal.hide("voucherEditModal");
          this.editUnitPrice="";
          this.editExpiryDate="";
          let delay = 1500;
          if($vm.voucherForm.length>20){
            delay = 1000 * ($vm.voucherForm.length/20);
          }
      setTimeout(async () => {
        await this.voucherModal(this.voucherClone);
        await this.setVoucherSummaryCustomer(this.filterObj);
        Swal.fire("Vouchers Edited!", "success");
      }, delay);
    },
    async voucherEdit(id, num, operation) {
      let url = this.$api.VOUCHER;
      let body = {};
      let result = {};
      if (operation == "expiry") {
        let date = new Date(num).getTime().toString().slice(0,10);
        body = { expiryDate: Number(date) };
      } else if (operation == "price") {
        body = { price: Number(num) };
      }
      url = url + id + "/" + operation;
      await this.$axios({
        method: "post",
        url: url,
        data: body,
        headers: { token: this.$session.get("token") },
      })
        .then(function (response) {
          result = response;
        })
        .catch((err) => {
          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      return result;
    },
    async voucherEmit(id, operation) {
            let flag = false;
      await Swal.fire({
        title: `Confirm ${operation} voucher?`,
        showCancelButton: true,
        confirmButtonText: operation,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          flag = true;
        } else if (result.isDismissed) {
          flag = false;
        }
      });
      if (!flag) {
        return;
      }
      let url = this.$api.VOUCHER;
      url = url + id + "/" + operation;
      var result = [];
      this.isSpinnerShow2 = true;
      await this.$axios({
        method: "post",
        url: url,
        headers: { token: this.$session.get("token") },
      })
        .then(function (response) {
          result = response;
        })
        .catch((err) => {
          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });

      if (result.status == 200) {
        let body = "";
        if (operation.includes("unexpire")) {
          body = `Unexpired voucher ID: ${id}`;
        } else if (operation.includes("unredeem")) {
          body = `Unredeemed voucher ID: ${id}`;
        } else if (operation.includes("delete")) {
          body = `Deleted voucher ID: ${id}`;
        }
        this.toastrExe("Voucher Update", body, "success");
        await this.setVoucherSummaryCustomer(this.filterObj);
      } else {
        let body = "Operation failed!";
        this.toastrExe("Voucher Update", body, "danger");
      }
      await this.voucherModal(this.voucherClone);
      this.isSpinnerShow2 = false;
    },
    toastrExe(title, body, variant) {
      this.$bvToast.toast(body, {
        title: title,
        variant: variant,
        solid: true,
      });
    },
    async selectAllVoucher(state) {
      await this.voucherForm.forEach((v) => {
        v.view = state == "true" ? true : false;
      });
    },
    expiryCheck(date) {
      date = date == "-" ? 0 : date;
      var formattedDate = moment(date,"DD/MM/YYYY").toDate();
      if (formattedDate < moment().toDate() && date != 0) {
        return true;
      } else {
        return false;
      }
    },
    async voucherModal(item) {
      this.voucherForm = [];
      this.expiredLength = 0; this.validLength = 0;
      this.voucherClone = item;
      this.isSpinnerShow2 = true;
      this.$bvModal.show("voucherModal");
      await this.setVoucherItems(this.voucherClone.memberID);
      this.voucher = this.voucherSKU.find((v) =>
        v.name.includes(item.voucherName)
      );
      if (this.voucher == undefined) {
        this.totalVouchers = 0;
      } else {
        this.voucher.vouchers = await this.voucher.vouchers.filter((v) => {
          if (v.memberID == item.memberID) {
            if (!Object.prototype.hasOwnProperty.call(v, "redeemed") && v.expired === undefined) {
              console.log(Date.now())
              if(v.expiryDate != 0 && (v.expiryDate*1000) < Date.now()){
                    this.expiredLength++;
                  }
                  else{
                    this.validLength++;
                  }
              v.expiryDate =
                v.expiryDate == 0
                  ? 0
                  : moment(new Date(v.expiryDate * 1000)).format("DD/MM/YYYY");
              this.voucherForm.push({
                id: v.trxnID,
                price: v.price,
                expiryDate: v.expiryDate,
                view: false,
              });
              return v;
            }
          }
        });
        this.totalVouchers = this.voucherForm.length;
      }
      this.$root.$emit("bv::refresh::table", "voucherTable");
      this.isSpinnerShow2 = false;
    },
    formatPrice(price) {
      return formatPrice(price);
    },
    async setVoucherSummaryCustomer(filterObj) {
      this.voucherItems = [];
      this.filterObj = filterObj;
      var endDateFilter =
        "&startCreateDate=0&endCreateDate=" +
        moment(filterObj.dateBalance.startDate).unix();
      var dateFilter = !filterObj.dateFilter
        ? ""
        : "&startExpiryDate=" +
          moment(filterObj.date.startDate).unix() +
          "&endExpiryDate=" +
          moment(filterObj.date.endDate).unix();
      var searchFilter =
        filterObj.searchVoucher == ""
          ? ""
          : "&search=" + filterObj.searchVoucher;
      this.isSpinnerShow = true;
      var result = await this.getVoucherBalance(
        endDateFilter + dateFilter + searchFilter
      );
      var retData = setReturnData(result, this.totalEntries, this.page);
      this.totalPage = retData.totalPage;
      this.startPage = retData.startPage;
      this.endPage = retData.endPage;
      var group = _.groupBy(result, "memberID");
      for (var key in group) {
        var items = group[key];
        var total = 0;
        var amount = 0.0;
        for (var i = 0; i < items.length; i++) {
          total += items[i].total;
          amount += items[i].amount;
        }
        this.voucherItems.push({
          items: items,
          total: total,
          amount: amount,
        });
      }
      this.voucherItems.sort((a, b) => b.total - a.total);
      var summaryItem = {
        total: 0,
        amount: 0.0,
      };
      for (var j = 0; j < this.voucherItems.length; j++) {
        for (var k in this.voucherItems[j]) {
          this.collapse.push(false);
          if (k == "total") {
            summaryItem["total"] += this.voucherItems[j].total;
          } else if (k == "amount") {
            summaryItem["amount"] += parseFloat(
              this.voucherItems[j].amount.toFixed(2)
            );
          }
        }
      }
      this.$emit("setCustomerSummary", summaryItem);
      this.isSpinnerShow = false;
      await this.getExportData(
        "?report=1" + endDateFilter + dateFilter + searchFilter
      );
    },
    async getVoucherBalance(searchFilter) {
      let $vm = this;
      let QUERY_STRING = "?report=1&page=" + this.page + searchFilter;
      const url =
        this.$api.REPORT_VOUCHER + this.$api.REPORT_BALANCE + QUERY_STRING;
      var result = [];
      await $vm
        .$axios({
          method: "get",
          url: url,
          baseURL: $vm.$axios.defaults.baseURL,
          headers: { token: $vm.$session.get("token") },
        })
        .then(function (response) {
          result = response.data.result;
          $vm.totalEntries = response.data.count;
        })
        .catch((err) => {
          var error = err.response.data.error;
          if (error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      return result;
    },
    async getExportData(strFilter) {
      let $vm = this;
      const url =
        this.$api.REPORT_VOUCHER + this.$api.REPORT_BALANCE + strFilter;
      var result = [];
      await $vm
        .$axios({
          method: "get",
          url: url,
          baseURL: $vm.$axios.defaults.baseURL,
          headers: { token: $vm.$session.get("token") },
        })
        .then(function (response) {
          result = response.data.result;
        })
        .catch((err) => {
          var error = err.response.data.error;
          if (error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      this.exportData = result;
      this.setExportData(result);
    },
    setExportData(data) {
      var strDate = moment(this.filterObj.dateBalance.startDate).format(
        this.$msg.CST.DATE_FORMAT
      );
      let header =
        this.$msg.REPORT.HEADER +
        this.$i18n.t(`subMenu.salon_report_voucher`) +
        "(" +
        this.$i18n.messages[this.$i18n.locale].tab.reportCreditTabs[0].text +
        ")";
      var exportHeaders = [
        this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.salon_report_voucher`),
        this.$i18n.t("table.header.date") + ": " + strDate,
        this.$i18n.t("table.report_generate") +
          moment().format(this.$msg.CST.DATE_TIME_24),
        this.$i18n.t("salon_report.view") +
          this.$i18n.messages[this.$i18n.locale].tab.reportVoucherSummaryType[0]
            .text,
        " ",
      ];
      var exportFileName =
        header.split(" ").join("_") + strDate + this.$msg.REPORT.CSV;
      var exportData = [];
      for (var i = 0; i < data.length; i++) {
        exportData.push({
          index: i + 1,
          name: data[i].memberDisplayName,
          mobile: data[i].mobile,
          voucher: data[i].voucherName,
          total: data[i].total,
          amount: data[i].amount,
        });
      }
      var exportObj = {
        data: exportData,
        fields: this.exportFields,
        headers: exportHeaders,
        fileName: exportFileName,
      };
      this.$emit("setExportData", exportObj);
    },
    handlePagination(pg) {
      if (pg != null) {
        this.page = pg - 1;
        this.setVoucherSummaryCustomer(this.filterObj);
      }
    },
    async setVoucherItems(memberID) {
      var retData = await this.getVoucherItems(memberID);
      this.voucherSKU = [...retData];
      this.voucherData = [...retData];
      // this.voucherSKU = JSON.parse(JSON.stringify(retData));
      // this.voucherData = JSON.parse(JSON.stringify(retData));
    },
    async getVoucherItems(memberID) {
      let $vm = this;
      let QUERY_STRING = this.$api.VOUCHER + "?memberID=" + memberID+"&limit="+this.limit;
      const url = QUERY_STRING;
      var result = [];
      var members = [];
      await $vm
        .$axios({
          method: "get",
          url: url,
          headers: { token: $vm.$session.get("token") },
        })
        .then(function (response) {
          members = response.data.members;
          let skus = response.data.skus;
          let vouchers = response.data.vouchers;
          result = skus.map((s) => ({
            ...s,
            vouchers: vouchers.filter((v) => v.skuID === s.skuID),
          }));
          result = result.filter((item) => {
            if (item.name != "") return item;
          });
        })
        .catch((err) => {
          var error = err.response.data.error;
          if (error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      return result;
    },
  },
};
</script>
<style lang="scss" scoped>
@media (min-width:890px) {
  .modal-dialog{
      max-width:800px !important;
  }
}
.dropdown {
  position: relative;
  height: 0;
  overflow: hidden;
  transition: height 350ms;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1rem;
    background-image: linear-gradient(to top, white, rgba(white, 0));
  }

  &-enter,
  &-leave-to { opacity: 0 }

  &-leave,
  &-enter-to { opacity: 1 }

  &-enter-active,
  &-leave-active {
    position: absolute;
    width: 100%;
    transition: opacity 200ms ease-in-out;
  }

  &-enter-active { transition-delay: 100ms }
}
.border-top-bottom-2 {
  border-top-width: 2px !important;
  border-bottom-width: 2px !important;
}
.swal2-container {
  z-index: 30000 !important;
}

</style>